import { useQuery } from '@tanstack/react-query';
import { supabase, supabaseAdmin } from '@/lib/supabase';
import type { Organization, BillingEvent } from '@/lib/database.types';

export interface DashboardStats {
  total_clients: number;
  active_clients: number;
  trial_clients: number;
  suspended_clients: number;
  total_mrr: number;
  total_locations: number;
  total_registers: number;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_admin_dashboard_stats');

      if (error) throw error;
      return (data?.[0] || {
        total_clients: 0,
        active_clients: 0,
        trial_clients: 0,
        suspended_clients: 0,
        total_mrr: 0,
        total_locations: 0,
        total_registers: 0,
      }) as DashboardStats;
    },
  });
}

export function useRecentBillingEvents() {
  return useQuery({
    queryKey: ['dashboard', 'recent-events'],
    queryFn: async () => {
      const { data, error } = await supabaseAdmin
        .from('billing_events')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(10);

      if (error) throw error;
      return (data || []) as unknown as BillingEvent[];
    },
  });
}

export function useRecentClients() {
  return useQuery({
    queryKey: ['dashboard', 'recent-clients'],
    queryFn: async () => {
      const { data, error } = await supabaseAdmin
        .from('organizations')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(5);

      if (error) throw error;
      return (data || []) as unknown as Organization[];
    },
  });
}
